var exports = {
  "v": "dialogBody__BR5v3A",
  "l": "experimentsInput__oNSpnf",
};

module.exports = exports;
